import { storeToRefs } from 'pinia'
import type { ParsedToken } from 'firebase/auth'
import type { CustomClaims } from '~/types/users'
import { useOrganizationsStore } from '~/store/organizations'
import { useWorkspacesStore } from '~/store/workspaces'
import type { AppRoles } from '~/constants/user'
import type { OrganizationRoles } from '~/constants/organizations'
import type { WorkspaceRoles } from '~/constants/workspaces'
import { isUserGranted } from '~/utils/user'

type State = {
  claims: (ParsedToken & CustomClaims) | null
}

const state = reactive<State>({
  claims: null,
})

export default () => {
  const setClaims = (newClaims: State['claims']) => {
    state.claims = newClaims
  }

  return {
    ...toRefs(state),
    setClaims,
  }
}

export const isCurrentUserGrantedInApp = (minimumRole: AppRoles) => {
  return typeof state.claims?.appRole === 'number'
    && isUserGranted(state.claims.appRole, minimumRole)
}

export const isCurrentUserGrantedInOrganization = (minimumRole: OrganizationRoles) => {
  const organizationsStore = useOrganizationsStore()
  const { selectedOrganization, selectedOrganizationRole } = storeToRefs(organizationsStore)

  if (!selectedOrganization.value || typeof selectedOrganizationRole.value !== 'number') return false

  return isUserGranted<OrganizationRoles>(selectedOrganizationRole.value, minimumRole)
}

export const isUserGrantedInWorkspace = (
  minimumRole: WorkspaceRoles,
  userWorkspaceRole?: WorkspaceRoles,
) => {
  if (userWorkspaceRole) {
    // TODO: Check if user has access to the workspace
    return isUserGranted(userWorkspaceRole, minimumRole)
  }
  else {
    const workspacesStore = useWorkspacesStore()
    const { selectedWorkspace, selectedWorkspaceRole } = storeToRefs(workspacesStore)

    if (!selectedWorkspace.value || typeof selectedWorkspaceRole.value !== 'number') return false

    return isUserGranted<WorkspaceRoles>(selectedWorkspaceRole.value, minimumRole)
  }
}
